import { render, staticRenderFns } from "./DetailRichText.vue?vue&type=template&id=27066fbe&scoped=true&lang=pug&"
import script from "./DetailRichText.vue?vue&type=script&lang=js&"
export * from "./DetailRichText.vue?vue&type=script&lang=js&"
import style0 from "./DetailRichText.vue?vue&type=style&index=0&id=27066fbe&prod&lang=scss&scoped=true&"
import style1 from "./DetailRichText.vue?vue&type=style&index=1&id=27066fbe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27066fbe",
  null
  
)

export default component.exports